import { getLocalStoragePrivate, setLocalStoragePrivate } from '@/utils/storage-tools';

const LOCAL_STORAGE_KEY_CLOSE_TAB_SHOWED = 'LOCAL_STORAGE_KEY_CLOSE_TAB_SHOWED';

const LOCAL_STORAGE_KEY_CLOSE_TAB_NEVER_ASK = 'LOCAL_STORAGE_KEY_CLOSE_TAB_NEVER_ASK';

/** 设置关闭提示 */
export const setIsShowCloseTabTips = () => {
  // 保存当前状态到 localStorage
  setLocalStoragePrivate({
    id: LOCAL_STORAGE_KEY_CLOSE_TAB_SHOWED,
    key: LOCAL_STORAGE_KEY_CLOSE_TAB_SHOWED,
    data: { showed: 1 },
  });
};

/** 判断关闭提示是否展示过 */
export const isCloseTabTipsShowed = () => {
  // 保存当前状态到 localStorage
  return !!getLocalStoragePrivate({
    id: LOCAL_STORAGE_KEY_CLOSE_TAB_SHOWED,
    key: LOCAL_STORAGE_KEY_CLOSE_TAB_SHOWED,
  })?.showed;
};

/** 设置关闭提示不再询问 */
export const setCloseTabTipsNeverAsk = (value: boolean) => {
  // 保存当前状态到 localStorage
  setLocalStoragePrivate({
    id: LOCAL_STORAGE_KEY_CLOSE_TAB_NEVER_ASK,
    key: LOCAL_STORAGE_KEY_CLOSE_TAB_NEVER_ASK,
    data: { value: value ? 1 : 0 },
  });
};

/** 判断关闭提示是否不再询问 */
export const isCloseTabTipsNeverAsk = () => {
  // 保存当前状态到 localStorage
  return !!getLocalStoragePrivate({
    id: LOCAL_STORAGE_KEY_CLOSE_TAB_NEVER_ASK,
    key: LOCAL_STORAGE_KEY_CLOSE_TAB_NEVER_ASK,
  })?.value;
};

/** 绑定标签页关闭前事件 */
export const bindBeforeCloseTabEvent = (cb: () => void) => {
  // 端内 端外区别
  if (window.wpsQuery) {
    return;
  }
};
